// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"ae8e21f9b74350c3f5d4","245":"7a355a3fc222dd1ac2a2","452":"2cd77f62023ff5737992","453":"14c19a464c9e5cc8424d"}[chunkId] + ".js";
};